<template>
  <v-row justify="space-around">
    <v-menu rounded="0" offset-y>
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          icon
          color="orange"
          class="white--text ma-2"
          v-bind="attrs"
          v-on="on"
        >
          {{ selectedLang.code }}
        </v-btn>
      </template>

      <v-list>
        <v-list-item v-for="item in langs" :key="item.code" link>
          <v-list-item-title
            v-text="item.text"
            @click="setLang(item)"
          ></v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    colors: ["deep-purple accent-4", "error", "teal darken-1"],
    selectedLang: {
      code: "EN",
      text: "English"
    },
    langs: [
      {
        code: "EN",
        text: "English"
      },
      {
        code: "ID",
        text: "Bahasa"
      }
    ]
  }),
  methods: {
    setLang(lang) {
      this.selectedLang = lang;
    }
  }
};
</script>
